export default function remainScrollAfterCtaAction($cta) {
    $(document).ready(() => {
        let scrollY = sessionStorage.getItem('scrollY', window.scrollY);

        if (scrollY) {
            $(window).scrollTop(+scrollY);
            sessionStorage.removeItem('scrollY');
        }
    });

    $cta.on('click', function (e) {
        sessionStorage.setItem('scrollY', window.scrollY);
    });
}


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/remainScrollAfterCtaAction.js